export default __webpack_public_path__ + "static/media/music_icon.e433a093.svg";